import JSONAPISerializer from 'ember-data/serializers/json-api';

export default class SubscriptionBatchSerializer extends JSONAPISerializer {
  attrs = {
    status: {
      serialize: false,
    },
  };
}
